import {
  GET_PREPAIDCARD_FAILED,
  GET_PREPAIDCARD_NOTFOUND,
  GET_PREPAIDCARD_SUCCESS,
  GET_PREPAIDCARD_INVALID_REQUEST,
  RESET_GET_PREPAIDCARD,
  LOADING_GET_PREPAIDCARD,
  BLOCK_CARD_SUCCESS,
  UNBLOCK_CARD_SUCCESS,
  ACTIVATE_PREPAIDCARD_SUCCESS
} from "../types";

const initialState = {
  isLoading: false,
  notFound: false,
  failed: false,
  invalidRequest: false,
  success: false,
  data: {}
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_GET_PREPAIDCARD:
      return {
        ...state,
        isLoading: true,
        notFound: false,
        success: false,
        invalidRequest: false,
        failed: false
      };
    case GET_PREPAIDCARD_NOTFOUND:
      return {
        ...state,
        isLoading: false,
        notFound: true,
        success: false,
        invalidRequest: false,
        failed: false
      };

    case GET_PREPAIDCARD_FAILED:
      return {
        ...state,
        isLoading: false,
        failed: true,
        notFound: false,
        success: false,
        invalidRequest: false
      };
    case GET_PREPAIDCARD_INVALID_REQUEST:
      return {
        ...state,
        isLoading: false,
        invalidRequest: true,
        failed: false,
        success: false,
        notFound: false
      };
    case GET_PREPAIDCARD_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        notFound: false,
        invalidRequest: false,
        failed: false,
        success: true,
        data: action.payload
      };
    }

    case BLOCK_CARD_SUCCESS: {
      return {
        ...state,
        data: {
          ...state.data,
          cardStatus: "50"
        }
      };
    }

    case UNBLOCK_CARD_SUCCESS: {
      return {
        ...state,
        data: {
          ...state.data,
          cardStatus: "40"
        }
      };
    }

    case ACTIVATE_PREPAIDCARD_SUCCESS: {
      return {
        ...state,
        data: {
          ...state.data,
          cardStatus: "40"
        }
      };
    }

    case RESET_GET_PREPAIDCARD:
      return (state = initialState);

    default:
      return state;
  }
};
